<template>
    <div class="dialog" v-if="dialogShow">
        <div class="content">
            <div class="title">{{dialog.title}}</div>
            <div class="describle">{{dialog.describle}}</div>
            <div class="buttons">
                <div class="iscancel" style="" v-if="dialog.iscancel && dialog.iscancel.length > 0" @click="cancel">{{dialog.iscancel}}</div>
                <div class="istrue" @click="isTrue(dialog.callbackf)">{{dialog.istrue}}</div>
            </div>
        </div>
    </div>
</template>
<script>
    import Bus from './bus.js'
    export default {
        props:[],
        data(){
            return {
                dialog:{
                    title:'',
                    describle:'',
                    cancel:'',
                    callbackf:function(){}
                },
                dialogShow:false,
            }
        },
        mounted() {
            let me = this;

             Bus.$on('showdialog', (dialog) => {
                me.dialog = dialog;
                me.dialogShow = true;
            })
             Bus.$on('hidedialog', () => {
                // me.dialog = dialog;
                me.dialogShow = false;
            })
            
        },
        methods:{
            cancel(){
                this.dialogShow = false;
            },
            isTrue(callbackf){
                this.dialogShow = false;
                if(typeof callbackf === 'function'){
                    callbackf()
                }
            },
           

        }
    }
</script>
<style scoped>
.dialog{
    position: fixed;
    width: 100%;
    height: 100%;
    text-align: center;
    z-index: 1001;
    left: 0;
    top: 0;
    overflow: auto;
    background: rgba(0, 0, 0, 0.4);
}

    .content{
        background: #fff;
        width: 80%;
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate3d(-50%, -50%, 0);
        transform: translate3d(-50%, -50%, 0);
        box-sizing: border-box;
        border-radius: 5px;
        z-index: 1001;
       
    }
    .title{
        height: 0.4rem;
        line-height: 0.4rem;
        font-size: 0.36rem;
        color: #000;
        margin: 0.58rem 0 0px 0;
        text-align:center;
    }
    .describle{
        line-height: 0.4rem;
        font-size: 0.3rem;
        color: #333;
        text-align:center;
        margin: 15px 25px 0;
        padding-bottom: 15px;
    }
    .buttons{
        table-layout: fixed;
        display: table;
        margin: 0px 0 0;
        width: 100%;
        border-top: 1px solid #e4e4e4;
    }
    .buttons div{
        padding: 0;
        font-size: 0.36rem;
        width: 100%;
        display: table-cell;
        float: none;
        text-align: center;
        height: 1rem;
        line-height: 1rem;
        cursor: pointer;
    }
    .iscancel{
        border-right: 1px solid #e4e4e4;
        color: #333;
    }
    .istrue{
        color: #18b86e
    }
</style>


// WEBPACK FOOTER //
// src/components/showmodel.vue